import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class MedicoServico extends Servico {
  constructor() {
    super('medico')
  }

  relatorioIndicacaoMedico(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/relatorioIndicacao`, { params: filtro })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default MedicoServico
